import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import NumberDataPod from '../../../components/NumberDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.student-life.campus-pride.title',
    defaultMessage: 'Campus Pride Index: LGBTQ-Friendly Rating',
  },
  outof: {
    id: 'hubs.student-life.campus-pride.out-of',
    defaultMessage: 'out of 5 stars',
  },
  learnMore: {
    id: 'hubs.student-life.campus-pride.learn-more',
    defaultMessage: 'Learn More About Campus Pride',
  },
  tooltip: {
    id: 'hubs.student-life.campus-pride.tooltip',
    defaultMessage:
      'The campus pride index is an overall indicator of institutional commitment to LGBTQ-inclusive policy, program and practice.',
  },
});

const CampusPride = ({ campusPride, intl }) => {
  const title = intl.formatMessage(messages.title);
  const outOf = intl.formatMessage(messages.outof);

  return !Number.isNaN(+campusPride) && +campusPride > 0 ? (
    <NumberDataPod
      header={title}
      tooltip={intl.formatMessage(messages.tooltip)}
      ariaLabel={`${title}, ${campusPride} ${outOf}`}
      content={{
        value: +campusPride,
        valueFooter: outOf,
        linkText: intl.formatMessage(messages.learnMore),
        linkUrl: 'http://www.campusprideindex.org/search',
        external: true,
      }}
    />
  ) : null;
};

CampusPride.propTypes = {
  campusPride: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(CampusPride);
